import {corePublicApolloClient, throwGQLErrorMessage} from '../../utils/apollo-client';
import { resendValidation as mutation } from '../graphql/sign-up';

export default async function resendValidationApi(oldToken, tokenType) {
  const response = await corePublicApolloClient()
    .then((client) =>
      client.mutate({
        mutation,
        variables: { oldToken, tokenType }
      })
    )
    .catch(throwGQLErrorMessage);

  return response.data.resendValidation;
}
